const LIST_URL = "/v1/payment-method/list";
const ADD_URL = "/v1/payment-method/add";
const UPDATE_URL = "/v1/payment-method/update";


const PAYMENT_API_URL_LIST = {
    LIST_URL,
    ADD_URL,
    UPDATE_URL
}

export { PAYMENT_API_URL_LIST };